import React from 'react'
import classNames from 'classnames'
import {
  LeaseApplication,
  LeaseApplicationStatus,
  LeaseUnitDetail,
  User
} from '../../types/app-types'
import {hasApplicationStatus} from '../../services/utils'
import ApplicationForm from './ApplicationForm'
import ApplicationFormPdfViewer from './ApplicationFormPdfViewer'

interface ApplicationFormCardProps {
  leaseApplication: LeaseApplication
  leaseUnitDetail: LeaseUnitDetail
  leaseApplicant: User
  onNext: (e: any) => void
  onUpdate: (updates: Record<string, any>) => void
}

const ApplicationFormCard = ({
  leaseApplication,
  leaseUnitDetail,
  leaseApplicant,
  onNext,
  onUpdate
}: ApplicationFormCardProps) => {
  const isFormCompleted = hasApplicationStatus(
    leaseApplication?.applicationStatus,
    LeaseApplicationStatus.FormCompleted
  )

  return (
    <div className="card-default w-full">
      <div className="card-body-default">
        <h1 className="card-header">Lease Application Form</h1>
        <div className="flex-grow">
          {isFormCompleted ? (
            <ApplicationFormPdfViewer
              leaseApplication={leaseApplication}
              onNext={onNext}
            />
          ) : (
            <ApplicationForm
              leaseApplication={leaseApplication}
              leaseUnitDetail={leaseUnitDetail}
              leaseApplicant={leaseApplicant}
              onUpdate={onUpdate}
            />
          )}
        </div>
        <div className="card-actions flex-none mt-8 flex flex-row justify-end">
          <button
            className={classNames('btn', {
              'btn-primary': isFormCompleted,
              'btn-disabled': !isFormCompleted
            })}
            onClick={onNext}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  )
}

export default ApplicationFormCard
